export const prepareUrl = (url, code) => {
    const splitUrl = url.split('/')
    if(splitUrl?.includes('incident')){
        return `/incident/${code}`
    }else {
        return url
    }
}